<div *transloco="let t; read: 'permit.publicStatus'" class="status" [class]="'status--' + status.toString()">
    {{ t(status.toString()) }}
</div>
